module.exports = __webpack_public_path__ + "static/media/tiplot.e9df4efd.avif";